import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faUnlock } from '@fortawesome/free-solid-svg-icons'
import { PATH_REQUEST_PASSWORD_RESET } from 'routing/path'
import logInUserAction from 'actions/admin-user/action.user-log-in'
import { getTranslations } from 'store/admin-translation/reducer.translations'
import { useCheckPermissions } from 'hooks/use-check-permissions';

const SignIn = () => {
  const [submitEnabled, setSubmitEnabled] = useState(true);
  const mounted = useRef(false);
  useEffect(() => {
      mounted.current = true;
      return () => { mounted.current = false; };
  }, []);

  const dispatch = useDispatch()
  const translations = useSelector(getTranslations);

  var result = useCheckPermissions();
  if (result != null)
    return result;

  const handleSubmit = fields => {
    const userCredentials = {
      login: fields?.login,
      password: fields?.password,
      rememberMe: fields?.rememberMe
    };

    setSubmitEnabled(false);
    setTimeout(() => mounted.current && setSubmitEnabled(true), 1000);

    dispatch(logInUserAction(userCredentials));
  };
  
  const validationSchema = Yup.object().shape({
    login: Yup.string()
      .required(translations.warningFieldRequired),
    password: Yup.string()
      .required(translations.warningFieldRequired)
  });

  const initialValues = {
    login: "",
    password: "",
    rememberMe: false
  };

  const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 5);
  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <div className="container">
            <div className="row justify-content-center form-bg-image">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <h1 className="mb-0 h3">{translations.signIn}</h1>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={fields => { handleSubmit(fields) }}>
                    { ({ errors, touched }) => (
                      <Form autoComplete={randomAutoComplete}>
                        <div className="form-group mb-4">
                          <label htmlFor="login">{translations.login}</label>
                          <div className="input-group">
                            <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faUser} /></span>
                            <Field id="login" name="login" type="text" placeholder={translations.login} className={`form-control ${errors.login && touched.login ? "is-invalid" : ""}`} autoFocus />
                            <ErrorMessage name="login" component="div" className="invalid-feedback" />
                          </div>
                        </div>
                        <div className="form-group mb-4">
                          <label htmlFor="password">{translations.password}</label>
                          <div className="input-group">
                            <span className="input-group-text" id="basic-addon2"><FontAwesomeIcon icon={faUnlock} /></span>
                            <Field id="password" name="password" type="password" placeholder={translations.password} className={`form-control ${errors.password && touched.password ? "is-invalid" : ""}`} />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-top mb-4">
                          <div className="form-check">
                            <Field id="rememberMe" name="rememberMe" type="checkbox" className="form-check-input" />
                            <label className="form-check-label mb-0" htmlFor="remember">{translations.rememberMe}</label>
                          </div>
                        </div>
                        <div className="d-grid mb-4">
                          <button id="signInButton" type="submit" className="btn btn-dark" disabled={submitEnabled ? null : 'disabled'}>{translations.signIn}</button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                  <Link className="float-end" to={PATH_REQUEST_PASSWORD_RESET}>{translations.forgotPassword}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default SignIn;
